<template>
	<page>
		<module>
			<module-tab name="服务分类" enable-flex>
				<m-operate>
					<c-button color="sys" prepend-icon="tf-plus" @click="addHandle(0)">新增一级分类</c-button>
                    <c-button color="red" @click="releaseHandle()">发布</c-button>
				</m-operate>
				
				<c-table ref="table" height="grow" :paging="false">
					<c-table-column
						type="expand"
						label="分类名称"
						add-button="添加子分类"
						expand-limit="2"
						width="300"
						@handle="loadChildren"
						@add="addHandle"
					>
						<template #default="{data}">
							{{data.group_name}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="图片"
					>
						<template v-slot="{data}">
							<c-file v-if="data.img_url" :src="data.img_url" media style="width: 40px; height: 40px;"></c-file>
						</template>
					</c-table-column>
					
					<c-table-column
						type="sort"
						label="排序"
						@handle="sortHandle"
					></c-table-column>
					
					<c-table-column
						type="button"
						fixed="right"
						label="操作"
						width="110"
					>
						<template v-slot="row">
							<c-table-button @click="editHandle(row)">编辑</c-table-button>
							<c-table-button @click="deleteHandle(row)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</module-tab>
			
			<product-list></product-list>
		</module>
		
		<c-dialog ref="dialog" :title="editState ? '编辑分类' : '添加分类'" width="600" height="300" @resolve="addChild">
			<c-form ref="form">
				<c-form-item label="分类名称" required>
					<c-input name="group_name"></c-input>
				</c-form-item>
				<c-form-item v-show="editLevel == 1" label="分类图片" required>
					<c-upload-file name="img_url" media></c-upload-file>
				</c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	import productList from './product_ungroup.vue'
	
	export default {
		components: {
			productList
		},
		
		data() {
			return {
				editState: false,
				editLevel: 0
			}
		},
		
		mounted() {
			this.$refs.table.load({
				url: '/product_group/list',
				data: {
					parent_id: 0
				}
			});
		},
		
		methods: {
			loadChildren(row, resolve) {
				this.request({
					url: '/product_group/list',
					data: {
						parent_id: row.data.id
					},
					success: data => {
						resolve(data);
					}
				});
			},
			
			addHandle(row, resolve) {
				this.editState = false;
				this.editLevel = row ? row.expandData.level + 1 : 0;
				this._edit = 0;
				this._parent = row ? row.data.id : 0;
				this._resolve = data => {
					row ? resolve(data) : this.$refs.table.push(data);
				};
				this.$refs.form.clear();
				this.$refs.dialog.open();
			},
			
			editHandle(row) {
				this.editState = true;
				this.editLevel = row.expandData.level;
				this._edit = row.data.id;
				this._parent = row.expandData.parent ? row.expandData.parent.data.id : 0;
				this._resolve = data => {
					row.update(data);
				};
				this.$refs.form.clear();
				this.$refs.form.set(row.data);
				this.$refs.dialog.open();
			},
			
			deleteHandle(row) {
                this.$confirm({
                    message: '确定要删除分类【'+row.data.group_name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product_group/delete',
                            data: {
                                group_id: row.data.id
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    message: '删除成功'
                                });
                                row.remove();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
			},
			
			sortHandle(row, type, next) {
				this.request({
					url: '/product_group/sort',
					data: {
						group_id: row.data.id,
						parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
						sort_type: type
					},
					loading: true,
					success: data => {
						next();
					}
				});
			},
			
			addChild(stop, next) {
				stop();
				this.$refs.form.submit({
					url: '/product_group/edit',
					rule: {
						group_name: '请填写分类名称',
						img_url: [{
							type: 'empty',
							message: '请选择分类图片',
							skip: () => {
								return this.editLevel != 2
							}
						}],
						redirect_params: [{
							type: 'empty',
							message: '请选择跳转链接',
							skip: () => {
								return this.editLevel != 2
							}
						}]
					},
					dataFormatter: data => {
						return Object.assign(data, {
							group_id: this._edit,
							parent_id: this._parent
						});
					},
					success: (data, res) => {
						this.$message({
							message: this._edit ? '编辑成功' : '添加成功'
						});
						next();
						this._resolve(res);
					}
				})
			},

            //发布
            releaseHandle(row, resolve) {
                this.$confirm({
                    message: '确定要发布吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product_group/release',
                            data: {},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '发布成功',
                                    icon: 'success'  // 图标（success：成功，fail：失败）
                                });
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
		}
	}
</script>